/*---------------------------------------------------------------
 ?? Project: Ring2All Platform
 ????? Author: Rodrigo Cuadra
 ?? Company: Ring2All LLC
 ?? File: components\ApiKeyGeneratedBanner.tsx
 ??? Created: 2026-05-02
 ?? Description:
    Implementation of the Application Keys module.
----------------------------------------------------------------*/


import { Key } from 'lucide-react';
import { SecretDisplay } from '../../../components/ui/SecretField';
import { useI18n } from '../../../hooks/useI18n';

interface Props { apiKey: string; }

export function ApiKeyGeneratedBanner({ apiKey }: Props) {
    const { t } = useI18n();
    return (
        <div className="mt-6 pt-6 border-t border-border">
            <label className="mb-3 block text-sm font-medium text-foreground">{t('apiKeys.sections.generatedKeyTitle')}</label>
            <div className="rounded-lg border border-green-200 bg-green-50 p-4 dark:border-green-800 dark:bg-green-900/20">
                <div className="flex items-start gap-3">
                    <Key className="mt-0.5 h-5 w-5 text-green-600 dark:text-green-400" />
                    <div className="flex-1 space-y-3">
                        <div>
                            <h4 className="mb-3 flex items-center gap-2 text-sm font-medium text-green-900 dark:text-green-100">{t('apiKeys.generatedKey.heading')}</h4>
                            <SecretDisplay value={apiKey} className="font-mono text-sm" blurClass="blur-md" />
                        </div>
                        <div className="space-y-1 text-xs text-green-800 dark:text-green-200">
                            <p><span aria-hidden="true">?? </span><strong>{t('apiKeys.generatedKey.importantLabel')}:</strong>{' '}{t('apiKeys.generatedKey.importantDescription')}</p>
                            <p>� {t('apiKeys.generatedKey.reveal')}</p>
                            <p>� {t('apiKeys.generatedKey.copy')}</p>
                            <p>� {t('apiKeys.generatedKey.usage')}{' '}<code>Authorization: Bearer &lt;your_api_key&gt;</code></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
